import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import state from "./state";

const engagementAttributionsStore = {
  state,
  getters,
  mutations,
  actions,
};
export default engagementAttributionsStore;
